const index = {
    state: {
        cart: [],
        count: 0,
        total: 0,
        items: [],
        filtered_items: [],
        lease: false,
        selected_lease: null,
        additional_items: [],
        view_count: 0,
        customer: null
        // documents: [],
        // notes: [],
        // prospectNotes: [],
        // paymentTotals: [],
        // paymentTypes: [],
        // remainingCharges: [],
        // customer: {"contacts": null},
        // prospect: {},
        // pastUnitsData: [],
        // wallets: [],
        // totalRemaining: "0.00",
        // transactionExpressCredentials: [],
        // unitsData: [],
        // selected_contact: [{"emails": null, "phones": null, "addresses": null}],
        // selected_contact_id: null,
        // primary_wallet_id: null,
    },

    getters: {
        /*customerDocuments:(state) => { return state.customerDocuments },
        notes:(state) => { return state.notes },
        paymentTotals:(state) => { return state.paymentTotals },
        paymentTypes:(state) => { return state.paymentTypes },
        invoices:(state) => { return state.invoices },
        customer:(state) => { return state.customer },
        pastUnitsData:(state) => { return state.pastUnitsData },
        wallets:(state) => { return state.wallets },
        totalRemaining:(state) => { return state.totalRemaining },
        transactionExpressCredentials:(state) => { return state.transactionExpressCredentials },
        unitsData:(state) => { return state.unitsData }*/
    },

    mutations: {
        update_view_count(state, payload) {
            state.view_count = payload;
        },
        setCustomer(state, payload) {
            state.customer = payload;
        },
        update_items(state, payload) {
            state.items = payload;
            state.filtered_items = payload;
        },
        update_filtered_items(state, payload) {
            state.filtered_items = state.items.filter(item => item.name.toLowerCase().includes(payload.toLowerCase())
                || item.product_name.toLowerCase().includes(payload.toLowerCase())
            );
            let additional = state.additional_items.filter(item => item.name.toLowerCase().includes(payload.toLowerCase())
                || item.product_name.toLowerCase().includes(payload.toLowerCase())
            );
            if (additional) {
                state.filtered_items.push(...additional);
            }
        },
        update_item_quantity(state, payload) {
            state.filtered_items.find(item => item.id === payload.id).quantity = payload.quantity;
        },
        update_additional_items(state, payload) {
            if (payload) {
                state.items.push(...payload);
            }
            /*state.additional_items = payload;*/
        },
        update_cart(state, payload) {
            let findIdx = state.cart.findIndex(item => item.id === payload.id);
            if (findIdx === -1) {
                payload.quantity = 1;
                state.cart.push(payload);
                /*payload.product_type_id_tree.forEach(id => {
                    if (id === 100) {
                        state.selected_lease = payload;
                        // TODO probably get any admin fee from DB based on campaign
                        state.cart.push(
                            {
                                "id": "-5",
                                "name": "Administration Fee",
                                "inventory_id": "",
                                "product_id": "",
                                "product_type": "Fee",
                                "product_name": "Adminstration Fee",
                                "offer_rate": "15.00",
                                "dont_show_remove": true,
                                "quantity": 1
                            });
                        state.lease = true;
                        state.selected_lease = payload;
                    }
                })*/
            } else {
                if (!state.cart[findIdx].product_type_id_tree.includes(100)) {
                    state.cart[findIdx].quantity ++;
                    //state.cart[findIdx].quantity ++;
                    //console.log("state.cart[findIdx].quantity", state.cart[findIdx].quantity);
                    //console.log("stage.cart", state.cart);
                }
            }
        },
        remove_from_cart(state, payload) {
            let idx = state.cart.findIndex(item => item.id === payload.id);
            state.cart.splice (idx, 1);
            /*if (payload.product_type_abbrv_tree[2] === "LEASE") {
                state.lease = false;
                let idx = state.cart.findIndex(item => item.id === "-5");
                state.cart.splice (idx, 1);
                state.selected_lease = null;
            }*/
        },
        update_count(state) {
            let total = 0;
            state.cart.forEach(item => {
                if (!item.quantity) item.quantity = 1;
                for (let i = 0; i < item.quantity; i++) {
                    total ++;
                }
            });
            state.count = total;
        },
        update_total(state) {
            let total = 0;
            state.cart.forEach(item => {
                if (!item.quantity) item.quantity = 1;
                for (let i = 0; i < item.quantity; i++) {
                    total += parseInt(item.offer_rate);
                }
            });
            state.total = total;
        }

        // updateDocuments(state, payload) { state.documents = payload; },
        // updateNotes(state, payload) { state.notes = payload },
        // updateProspectNotes(state, payload) { state.prospectNotes = payload },
        // updatePaymentTotals(state, payload) {
        //     state.paymentTotals = payload;
        //     console.log("??? state.paymentTotals", state.paymentTotals);
        // },
        // updatePaymentTypes(state, payload) { state.paymentTypes = payload },
        // updateRemainingCharges(state, payload) {
        //     state.remainingCharges = payload;
        //     console.log("state.invoices", state.remainingCharges);
        // },
        // updateCustomer(state, payload) {
        //     state.customer = payload;
        //     state.selected_contact = state.customer.contacts.find(contact => contact.id === state.customer.primary_contact_id);
        //     state.selected_contact_id = state.selected_contact.id;
        // },
        // update_selected_contact(state, payload) {
        //     state.selected_contact = payload;
        // },
        // update_selected_id(state, payload) {
        //     state.selected_contact_id = payload;
        // },
        // updateProspect(state, payload) { state.prospect = payload },
        // updatePastUnitsData(state, payload) { state.pastUnitsData = payload },
        // updateWallets(state, payload) { state.wallets = payload },
        // updatePrimaryWalletId(state, payload) { state.primary_wallet_id = payload; },
        // updateTotalRemaining(state, payload) { state.totalRemaining = payload },
        // updateTransactionExpressCredentials(state, payload) { state.transactionExpressCredentials = payload },
        // updateUnitsData(state, payload) { state.unitsData = payload },
    },

    actions: {
        /*increment (ctx) {
            ctx.commit('increment')
        },*/

    }
}

export default index;

